function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';

// Local Definitions

import { Choice } from "./common";
import { FormDescription, FormLabel } from "../../common";
import "./styles.scss";
const baseClassName = styleNames.base;
const componentClassName = 'choices-input';

/**
 * This is the component description
 */
const ChoicesInput = ({
  id,
  className: userClassName,
  style,
  name,
  validate,
  options,
  multiple,
  color,
  label,
  labelColor,
  optional,
  disabled,
  description,
  spaceBetween,
  ...otherProps
}) => /*#__PURE__*/React.createElement("div", {
  id: id,
  className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
  style: style
}, label && /*#__PURE__*/React.createElement(FormLabel, {
  name: name,
  color: labelColor,
  optional: optional
}, label), /*#__PURE__*/React.createElement("div", {
  className: ['choices', spaceBetween && 'space-between'].filter(Boolean).join(' ')
}, options.map(choice => /*#__PURE__*/React.createElement(Choice, _extends({
  className: `x-${color}`,
  key: choice.value,
  name: name,
  id: `${name}-${choice.value}`,
  multiple: multiple,
  validate: validate,
  disabled: disabled
}, otherProps, choice)))), /*#__PURE__*/React.createElement(FormDescription, {
  className: "s-1",
  description: description,
  name: name
}));
ChoicesInput.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The choices name
   */
  name: PropTypes.string.isRequired,
  /**
   * The input field validator function
   */
  validate: PropTypes.string,
  /**
   * The choices input options
   */
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })),
  /**
   * If the input should be multiple - checkbox
   */
  multiple: PropTypes.bool,
  /**
   * how many columns should be displayed on the mobile grid
   */
  gridColumnsMobile: PropTypes.number,
  /**
   * The choice color
   */
  color: PropTypes.string,
  /**
   * The selected choice color
   */
  colorChecked: PropTypes.string,
  /**
   * The label of the choices input
   */
  label: PropTypes.string,
  /**
   * Whether all the Choices inputs should be disabled
   */
  disabled: PropTypes.bool,
  /**
  * Whether the input is optional or not
  */
  optional: PropTypes.bool,
  /**
   * The select input description
   */
  description: PropTypes.string,
  /**
  * The number of columns the label should span
  */
  labelSpan: PropTypes.number,
  /**
   * The number of columns the input should span
   */
  inputSpan: PropTypes.number,
  /**
   * The number of columns the label should span on desktop
   */
  desktopLabelSpan: PropTypes.number,
  /**
   * The number of columns the input should span on desktop
   */
  desktopInputSpan: PropTypes.number,
  /**
   * The color of the label
   */
  labelColor: PropTypes.string
};
ChoicesInput.defaultProps = {
  color: 'interactive',
  disabled: false
};
export default /*#__PURE__*/memo(ChoicesInput);